import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Slider from 'react-slick'
import { useTranslation } from 'react-i18next'
import CasinoGameCard from '../CasinoGameCard/index'
import { LOADER_HANDLER_TYPES } from 'constants/index'
import Loader from 'components/ui-kit/Loader/index'
import ContentHeader from 'components/ui-kit/ContentHeader/index'
import { FavStarHeadingIcon } from 'components/ui-kit/Icons/svg/index'
import { openInfoToaster } from 'helpers/toaster.helpers'
import { setGameCategory, setProvider, setSearchGame, setTab, setViewFavGame } from 'redux-thunk/redux/slices/lobby.slice'
import { setShowAllFavGames } from 'redux-thunk/redux/slices/games.slice'

const CasinoGamesListing = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { homeCasinoSettings } = props
  const { gameTab, searchGame } = useSelector((state) => state?.lobby)
  const { categoryWiseGamesList, favouriteGamesList, casinoCategoriesList } = useSelector(
    (state) => state.games
  )

  // const [categoryGames, setCategoryGames] = useState([])

  const viewAllHandler = (e, info) => {
    e.preventDefault()
    if (info?.title === 'Originals') {
      openInfoToaster({ message: 'Coming Soon!' })
    } else if (gameTab?.includes(info?.title)) {
      dispatch(setViewFavGame(info?.title))
      dispatch(setShowAllFavGames(true))
    } else {
      dispatch(setTab('game-search'))
      dispatch(setSearchGame(''))
      dispatch(setProvider(info?.provider))
      dispatch(setGameCategory(info?.gameCategory))
    }
  }

  const {
    [LOADER_HANDLER_TYPES.gameBarFavourites]: favouritesLoading,
    [LOADER_HANDLER_TYPES.categoryWiseGamesList]: gamesLoading
  } = useSelector(state => state.loader)

  const loadersCount = (casinoCategoriesList?.length - categoryWiseGamesList?.length) > 5
    ? 5
    : casinoCategoriesList?.length - categoryWiseGamesList?.length

  // useEffect(() => {
  //   categoryWiseGamesList?.map((item, i) =>
  //     setCategoryGames([...categoryGames, { order: casinoCategoriesList.filter(y => y.gameCategory === item.type)[0].sortOrder, ...item }])
  //   )
  // }, [categoryWiseGamesList])

  return (
    <>
      {categoryWiseGamesList.map((item, i) => {
        return (
          <section key={item.type} className='global-casino-section'>
            <ContentHeader
              title={item.type}
              subtitle={t('viewAll')}
              Icon={item.image || FavStarHeadingIcon}
              iconType={item.image ? 'png' : ''}
              subtitleOnClickHandler={viewAllHandler}
              showRecentlyPlayed
              showFavourites
              gameCategory={item.type}
            />
            <div className='slide-wrap p-0 m-0'>
              {item?.rows?.length > 0 && !gameTab?.includes(item.type)
                ? (
                  <Slider
                    {...homeCasinoSettings}
                    infinite={!(item?.rows?.length < 7)}
                  >
                    {item?.rows?.map((game) => (
                      <div key={game?.id} className='col px-1'>
                        <CasinoGameCard game={game} />
                      </div>
                    ))}
                  </Slider>
                  )
                : (
                  <>
                    {favouritesLoading && (item?.type === gameTab[gameTab?.length - 1]) && <Loader variant={LOADER_HANDLER_TYPES.content} />}
                    <Slider
                      {...homeCasinoSettings}
                      infinite={
                    !(
                      favouriteGamesList?.filter(
                        (favGame) => favGame.type === item?.type
                      )?.[0]?.rows.length < 7
                    )
                  }
                    >
                      {favouriteGamesList
                        ?.filter((favGame) => favGame.type === item?.type)?.[0]
                        ?.rows?.map((game) => (
                          <div key={game?.id} className='col px-1'>
                            <CasinoGameCard isFavourite game={game?.CasinoGame} />
                          </div>
                        ))}
                    </Slider>
                  </>)}
            </div>
          </section>
        )
      })}
      {(gamesLoading && !searchGame.length > 0) &&
      Array.from({ length: loadersCount }, (_, index) =>
        <section
          key={index}
          className='global-casino-section'
        >
          <div className='slide-wrap p-0 m-0'>
            <div
              className='col px-1'
            >
              <Loader variant={LOADER_HANDLER_TYPES.content} />
            </div>
          </div>
        </section>)}
    </>
  )
}

export default CasinoGamesListing
